import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null=loading, false=anon, object=user
    const [user, setUser] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
            localStorage.removeItem("scintilla_token");
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) localStorage.setItem("scintilla_token", data.token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return {
                ok: false,
                error: formatApiErrorDetail(e.response?.data?.detail) || e.message,
            };
        }
    };

    const register = async (payload) => {
        try {
            const { data } = await api.post("/auth/register", payload);
            return { ok: true, message: data.message };
        } catch (e) {
            return {
                ok: false,
                error: formatApiErrorDetail(e.response?.data?.detail) || e.message,
            };
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {
            console.error("Logout failed:", e);
        }
        localStorage.removeItem("scintilla_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
